import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * skcc_customer API
 * @author Ju
 */
export default {
  getSkccCustomerList() {
    return axios.get(`${baseUrl}/common/skcc/get-skcc-customer-list.do`);
  },
  insertSkccCustomer(params) {
    return axios.post(`${baseUrl}/common/skcc/insert-skcc-customer.do`, params);
  },
  updateSkccCustomerList(params) {
    return axios.post(`${baseUrl}/common/skcc/update-skcc-customer-list.do`, params);
  },
  deleteSkccCustomerList(params) {
    return axios.post(`${baseUrl}/common/skcc/delete-skcc-customer-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/model/skcc-customer.js